module.exports = __webpack_public_path__ + "static/media/img2.8818360e.jpg";